import type { RuntimePiece } from './state';

/** 选择提示目标：第一个未放置的块。 */
export function pickHintTarget(pieces: RuntimePiece[]): RuntimePiece | null {
  return pieces.find((p) => !p.placed) ?? null;
}

/**
 * 计算撤销某历史条目后 placedCount 的变化量。
 *  - 当前已放置、条目记录未放置（即撤销一次吸附）→ -1
 *  - 当前未放置、条目记录已放置 → +1
 *  - 否则 0
 */
export function computeUndoDelta(currentPlaced: boolean, entryPlaced: boolean): number {
  if (currentPlaced && !entryPlaced) return -1;
  if (!currentPlaced && entryPlaced) return 1;
  return 0;
}
